import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=1952271e&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"
import style0 from "./MasterForm.vue?vue&type=style&index=0&id=1952271e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952271e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1952271e')) {
      api.createRecord('1952271e', component.options)
    } else {
      api.reload('1952271e', component.options)
    }
    module.hot.accept("./MasterForm.vue?vue&type=template&id=1952271e&scoped=true", function () {
      api.rerender('1952271e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/cash-request-manager/MasterForm.vue"
export default component.exports